import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, ChevronDown } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";

export const ChangePasswordCard = () => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) return toast.error("New password must be at least 8 characters");
    if (next !== confirm) return toast.error("Passwords don't match");
    setBusy(true);
    try { await api.post("/auth/change-password", { current_password: current, new_password: next }); toast.success("Password changed"); setCurrent(""); setNext(""); setConfirm(""); }
    catch (err) { toast.error(errorMessage(err)); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="card-surface rounded-3xl p-5 space-y-3" data-testid="change-password-card">
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between gap-2 text-left" aria-expanded={open} data-testid="change-password-toggle">
        <span className="eyebrow flex items-center gap-1.5"><KeyRound size={12} /> Change password</span>
        <ChevronDown size={16} className={`text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <>
      <div><Label>Current password</Label><div className="mt-1.5"><PasswordInput required value={current} onChange={(e) => setCurrent(e.target.value)} className="bg-white/5 border-white/10" testId="password-current-input" /></div></div>
      <div><Label>New password</Label><div className="mt-1.5"><PasswordInput required minLength={8} value={next} onChange={(e) => setNext(e.target.value)} className="bg-white/5 border-white/10" testId="password-new-input" /></div></div>
      <div><Label>Confirm new password</Label><div className="mt-1.5"><PasswordInput required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="bg-white/5 border-white/10" testId="password-confirm-input" /></div></div>
      <Button type="submit" disabled={busy} variant="outline" className="w-full rounded-full border-white/15 bg-transparent hover:bg-white/10" data-testid="password-save-button">{busy ? "Saving…" : "Update password"}</Button>
      </>}
    </form>
  );
};
